document.addEventListener('DOMContentLoaded', function() {
	const videoModules = document.querySelectorAll('.module-video');
	
	videoModules.forEach(module => {
			const thumbnail = module.querySelector('.video-thumbnail');
			const modal = module.querySelector('.video-modal');
			const closeButton = module.querySelector('.close-button');
			const video = module.querySelector('video');
			
			if (thumbnail && modal && closeButton && video) {
					// Video öffnen
					thumbnail.addEventListener('click', function() {
							modal.classList.add('active');
							video.play();
					});
					
					// Video schließen
					closeButton.addEventListener('click', function() {
							modal.classList.remove('active');
							video.pause();
							video.currentTime = 0;
					});
					
					// Modal schließen bei Klick außerhalb
					modal.addEventListener('click', function(e) {
							if (e.target === modal) {
									modal.classList.remove('active');
									video.pause();
									video.currentTime = 0;
							}
					});
					
					// ESC-Taste zum Schließen
					document.addEventListener('keydown', function(e) {
							if (e.key === 'Escape' && modal.classList.contains('active')) {
									modal.classList.remove('active');
									video.pause();
									video.currentTime = 0;
							}
					});
			}
	});
}); 